import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Component, render } from "preact";
import { Tokens, formSubmit, getSession, getUserSession } from '../api/Client';
import { StripeElementTokenGenerator } from "../lib/StripeElementTokenGenerator";
import { CardBrand } from "../util/CardBrand";
import { extractOnlyStripeVendor, extractOnlyUnivapayVendor } from "../util/CreditCardVendor";
import { ValidationError } from "../util/FormValidation";
import StripeCardInputForm from "./stripe/StripeCardInputForm";
import UnivapayCardInputForm, { checkoutUnivapayToken } from './univapay/UnivapayCardInputForm';
const PaySplitCounts = [3, 5, 6, 10, 12, 15, 18, 20, 24];
const CardBrandIcons = {
    VISA: 'icon_cardbrand_visa.svg',
    MASTER: 'icon_cardbrand_mastercard.svg',
    AMEX: 'icon_cardbrand_amex.svg',
    JCB: 'icon_cardbrand_jcb.svg',
    DINERS: 'icon_cardbrand_diners.svg',
    DISCOVER: 'icon_cardbrand_discover.svg',
    UNIONPAY: 'icon_cardbrand_unionpay.svg',
};
export class PaymentMethodComponent extends Component {
    constructor() {
        super();
        this.state = {
            card: {
                cardBrandType: null,
                cardno: null,
                holdername: null,
                expiremonth: null,
                expireyear: null,
                cvc: null,
                sequence: null,
                paymentMethod: "BUNDLE",
                payTimes: 1,
                tokens: [],
                payType: "INPUT",
            },
            isLoaded: false,
            onlyStripeMerchant: undefined,
            onlyUnivapayMerchant: undefined,
            enablePaySplit: false,
            userCards: [],
            userCard: null,
            usableCardBrands: [],
            stripeTokenGenerator: new StripeElementTokenGenerator(null, null, null),
            errors: new ValidationError()
        };
        this.handleChange = this.handleChange.bind(this);
        this.handlePaymentMethod = this.handlePaymentMethod.bind(this);
        this.handleChangeStripeCardInput = this.handleChangeStripeCardInput.bind(this);
        this.getToken = this.getToken.bind(this);
        // 次画面遷移時のフォーム
        document.querySelector('.PaymentMethod__Submit')?.addEventListener('click', evt => {
            evt.preventDefault();
            const elm = evt.target;
            this.formAction = elm.getAttribute('href');
            this.formSelector = elm.getAttribute('data-form-id');
            this.formAttributePrefix = elm.getAttribute('data-form-attr-prefix');
            this.beforeSubmit();
        });
    }
    render() {
        // 有効期限(月)のDOM
        let expireMonthOptions = [];
        for (let monthIdx = 1; monthIdx < 13; monthIdx++) {
            const monthVal = `0${monthIdx}`.slice(-2);
            expireMonthOptions.push(_jsx("option", Object.assign({ value: monthVal }, { children: monthVal }), void 0));
        }
        // 有効期限(年)のDOM
        let expireYearOption = [];
        const currentDate = new Date();
        for (let yearIdx = 0; yearIdx < 10; yearIdx++) {
            const yearVal = `${currentDate.getFullYear() + yearIdx}`;
            expireYearOption.push(_jsx("option", Object.assign({ value: yearVal }, { children: yearVal }), void 0));
        }
        if (!this.state.isLoaded) {
            return null;
        }
        return (_jsxs("div", Object.assign({ class: "form-container" }, { children: [_jsx("div", Object.assign({ class: `notification is-text-danger ${this.hasError('token') ? '' : 'is-hidden'}` }, { children: this.state.errors.getMessage('token') }), void 0),
                _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u30AB\u30FC\u30C9\u60C5\u5831\u306E\u5165\u529B\u3001\u307E\u305F\u306F\u767B\u9332\u6E08\u307F\u306E\u30AB\u30FC\u30C9\u3092\u547C\u3073\u51FA\u3057" }), void 0),
                        _jsx("div", Object.assign({ class: "control select w100" }, { children: _jsxs("select", Object.assign({ class: "w100", name: "payType", onInput: this.handleChange }, { children: [_jsx("option", Object.assign({ value: "INPUT" }, { children: "\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u5165\u529B" }), void 0),
                                    _jsx("option", Object.assign({ class: this.state.userCards.length === 0 ? 'is-hidden' : '', value: "REGISTERED", disabled: this.state.userCards.length === 0 }, { children: "\u767B\u9332\u6E08\u307F\u306E\u30AB\u30FC\u30C9\u3092\u9078\u629E" }), void 0)] }), void 0) }), void 0)] }), void 0),
                this.state.card.payType === "REGISTERED" ? (_jsxs("article", { children: [_jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u767B\u9332\u6E08\u307F\u30AB\u30FC\u30C9\u60C5\u5831" }), void 0),
                                _jsx("div", Object.assign({ class: "control select w100" }, { children: _jsx("select", Object.assign({ class: "w100", onChange: e => this.setUserCard(e) }, { children: this.state.userCards.map(m => {
                                            return _jsxs("option", Object.assign({ value: m.id, selected: this.state.userCard?.id === m.id }, { children: [m.cardBrandType, " ", m.maskedCardNo] }), void 0);
                                        }) }), void 0) }), void 0)] }), void 0),
                        _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u304A\u652F\u6255\u3044\u65B9\u6CD5" }), void 0),
                                _jsx("div", Object.assign({ class: "select w100" }, { children: _jsx("select", Object.assign({ class: "w100", name: "paymentMethod", onChange: this.handlePaymentMethod }, { children: this.paymentMethods() }), void 0) }), void 0)] }), void 0),
                        _jsxs("div", Object.assign({ class: `field ${this.requirePayTimeInput() ? '' : 'is-hidden'}` }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u5206\u5272\u56DE\u6570" }), void 0),
                                _jsx("div", Object.assign({ class: "select w100" }, { children: _jsx("select", Object.assign({ class: "w100" }, { children: PaySplitCounts.map(m => {
                                            return (_jsxs("option", Object.assign({ value: m }, { children: [m, "\u56DE"] }), void 0));
                                        }) }), void 0) }), void 0)] }), void 0)] }, void 0)) : (_jsxs("article", { children: [_jsx(StripeCardInputForm, { storeIdentifier: this.state.onlyStripeMerchant?.storeIdentifier, onChange: this.handleChangeStripeCardInput }, void 0),
                        _jsx(UnivapayCardInputForm, { storeIdentifier: this.state.onlyUnivapayMerchant?.storeIdentifier, onlyUseBundle: this.state.enablePaySplit }, void 0),
                        (!this.state.onlyStripeMerchant && !this.state.onlyUnivapayMerchant) && (_jsxs("article", { children: [_jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u30AB\u30FC\u30C9\u756A\u53F7" }), void 0),
                                        _jsx("div", Object.assign({ class: "flex flex__row mb1" }, { children: this.state.usableCardBrands }), void 0),
                                        _jsx("input", { type: "text", class: `input ${this.hasError('cardno') ? 'is-danger' : ''}`, name: "cardno", maxLength: 16, onInput: e => this.handleChange(e), value: this.state.card.cardno ?? '' }, void 0), this.messages('cardno')] }), void 0),
                                _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u30AB\u30FC\u30C9\u540D\u7FA9\u4EBA" }), void 0),
                                        _jsx("input", { type: "text", name: "holdername", class: `input ${this.hasError('holdername') ? 'is-danger' : ''}`, maxLength: 50, value: this.state.card.holdername ?? '', onInput: e => this.handleChange(e) }, void 0), this.messages('holdername')] }), void 0),
                                _jsx("div", Object.assign({ class: "field is-horizontal" }, { children: _jsxs("div", Object.assign({ class: "field-body" }, { children: [_jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u6709\u52B9\u671F\u9650" }), void 0),
                                                    _jsxs("div", Object.assign({ class: "control flex flex__align_item_center" }, { children: [_jsx("div", Object.assign({ class: `select ${this.hasError('expiremonth') ? 'is-danger' : ''}` }, { children: _jsxs("select", Object.assign({ name: "expiremonth", onInput: e => this.handleChange(e) }, { children: [_jsx("option", Object.assign({ value: "" }, { children: "\u6708" }), void 0), expireMonthOptions] }), void 0) }), void 0),
                                                            _jsx("i", { class: "fas fa-slash fa-rotate-90 mx2" }, void 0),
                                                            _jsx("div", Object.assign({ class: `select ${this.hasError('expireyear') ? 'is-danger' : ''}` }, { children: _jsxs("select", Object.assign({ name: "expireyear", onInput: e => this.handleChange(e) }, { children: [_jsx("option", Object.assign({ value: "" }, { children: "\u5E74" }), void 0), expireYearOption] }), void 0) }), void 0)] }), void 0), this.messages('expiremonth'), this.messages('expireyear')] }), void 0),
                                            _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30B3\u30FC\u30C9" }), void 0),
                                                    _jsx("input", { type: "text", name: "cvc", class: `input w10rem ${this.hasError('cvc') ? 'is-danger' : ''}`, maxLength: 4, onInput: e => this.handleChange(e) }, void 0), this.messages('cvc')] }), void 0)] }), void 0) }), void 0),
                                _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u304A\u652F\u6255\u3044\u65B9\u6CD5" }), void 0),
                                        _jsx("div", Object.assign({ class: "select w100" }, { children: _jsx("select", Object.assign({ class: "w100", name: "paymentMethod", onChange: this.handlePaymentMethod }, { children: this.paymentMethods() }), void 0) }), void 0)] }), void 0),
                                _jsxs("div", Object.assign({ class: `field ${this.requirePayTimeInput() ? '' : 'is-hidden'}` }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u5206\u5272\u56DE\u6570" }), void 0),
                                        _jsx("div", Object.assign({ class: "select w100" }, { children: _jsx("select", Object.assign({ class: "w100", name: "payTimes", onChange: this.handleChange }, { children: PaySplitCounts.map(m => {
                                                    return (_jsxs("option", Object.assign({ value: m }, { children: [m, "\u56DE"] }), void 0));
                                                }) }), void 0) }), void 0)] }), void 0)] }, void 0))] }, void 0))] }), void 0));
    }
    componentDidMount() {
        // 対象の加盟店で使える登録済みカードを取得
        const sessonLoadJob = getUserSession().then(response => {
            const { cards } = response.data;
            const registeredCards = cards.filter(p => p.storeId === this.props.storeId);
            this.setState({
                userCards: cards.filter(p => p.storeId === this.props.storeId),
                userCard: registeredCards.length > 0 ? registeredCards[0] : null
            });
        });
        // 加盟店の情報を引いて利用可能なカードブランドを取得
        // 加盟店側の設定も合わせて確認して分割可能かを判断
        const storeTypeDetection = Tokens.getStoreInfo(this.props.storeId).then(response => {
            const storeInfo = response.data;
            const cardBrands = storeInfo.cardFees
                .filter(p => p.deleteFlag === "NOT_DELETED" && p.settingTarget === true).map(m => {
                const brand = m.cardBrandType;
                return (_jsx("img", { class: "icon__cardbrand", src: `/assets/images/${CardBrandIcons[brand]}` }, void 0));
            });
            const paymentSplittable = storeInfo.paymentSplitable === true;
            // Stripeしか使えない加盟店かどうか
            const onlyStripeMerchantConfig = extractOnlyStripeVendor(storeInfo.creditCardVendors);
            // UPCしか使えない加盟店かどうか
            const onlyUnivapayMerchantConfig = extractOnlyUnivapayVendor(storeInfo.creditCardVendors);
            // 通常決済の場合はセッションから商品情報を取得
            // 分割不可能な商品を判別
            if (this.props.cartType === "CART") {
                getSession().then(response => {
                    const productPaySplittable = response.data.cartDetails.filter(p => p.paymentSplit === false).length === 0;
                    const storePaySplittable = response.data.paymentSplitable === true;
                    this.setState({
                        usableCardBrands: cardBrands,
                        enablePaySplit: (productPaySplittable && storePaySplittable),
                        onlyStripeMerchant: onlyStripeMerchantConfig,
                        onlyUnivapayMerchant: onlyUnivapayMerchantConfig,
                    });
                });
            }
            else {
                this.setState({
                    usableCardBrands: cardBrands,
                    enablePaySplit: paymentSplittable && this.props.cartType !== 'FREEINPUT_RECURRING',
                    onlyStripeMerchant: onlyStripeMerchantConfig,
                    onlyUnivapayMerchant: onlyUnivapayMerchantConfig,
                });
            }
        });
        Promise.allSettled([sessonLoadJob, storeTypeDetection])
            .finally(() => {
            setTimeout(() => {
                this.setState({ isLoaded: true });
            }, 500);
        });
    }
    handleChange(event) {
        let state = this.state;
        const target = event.target;
        const stateName = target.getAttribute('name');
        // @ts-ignore
        state.card[stateName] = target.value;
        this.setState(state);
    }
    setUserCard(e) {
        const select = e.target;
        const selectedUserId = Number(select.value);
        const userCard = this.state.userCards.filter(p => p.id === selectedUserId)[0];
        this.setState({
            userCard: userCard
        });
    }
    requirePayTimeInput() {
        return this.state.card.paymentMethod === "SPLIT";
    }
    paymentMethods() {
        // 分割可能かどうか
        if (this.state.enablePaySplit === true) {
            switch (this.props.storeType) {
                case "GMO":
                    return [
                        _jsx("option", Object.assign({ value: "BUNDLE" }, { children: "\u4E00\u62EC" }), void 0),
                        _jsx("option", Object.assign({ value: "SPLIT" }, { children: "\u5206\u5272" }), void 0),
                        _jsx("option", Object.assign({ value: "REVOLVING" }, { children: "\u30EA\u30DC" }), void 0),
                    ];
                default:
                    return [
                        _jsx("option", Object.assign({ value: "BUNDLE" }, { children: "\u4E00\u62EC" }), void 0),
                        _jsx("option", Object.assign({ value: "SPLIT" }, { children: "\u5206\u5272" }), void 0),
                    ];
            }
        }
        return ([
            _jsx("option", Object.assign({ value: "BUNDLE" }, { children: "\u4E00\u62EC" }), void 0),
        ]);
    }
    handlePaymentMethod(evt) {
        const elm = evt.target;
        let card = this.state.card;
        card.paymentMethod = elm.value;
        switch (card.paymentMethod) {
            case "SPLIT":
                card.payTimes = 3;
                break;
            case "BONUS_SPLIT":
                card.payTimes = 2;
                break;
            default:
                card.payTimes = 1;
                break;
        }
        this.setState({ card: card });
    }
    handleChangeStripeCardInput(stripe, event, cardElement) {
        this.state.stripeTokenGenerator.change(stripe, cardElement, event);
    }
    beforeSubmit() {
        // カード入力は入力チェック
        if (this.state.card.payType === "INPUT") {
            this.getToken();
        }
        else {
            this.submit();
        }
    }
    submit() {
        let formParams = this.getPaymentFormObject();
        if (this.formAction) {
            formSubmit(formParams, this.formAction, this.formSelector, this.formAttributePrefix);
        }
    }
    getToken() {
        // Stripeのみの加盟店の場合
        if (this.state.onlyStripeMerchant) {
            const validationResult = this.state.stripeTokenGenerator.validate();
            if (validationResult.hasErrors()) {
                this.setState({ errors: validationResult });
                const invalidateEvent = new CustomEvent('--get-token-invalidate', {});
                document.dispatchEvent(invalidateEvent);
                return;
            }
            this.state.stripeTokenGenerator.createToken()
                .then((result) => {
                this.setState({
                    card: { ...result }
                }, () => {
                    this.submit();
                    // コンポーネント間のイベントバインド
                    const tokenGetEvent = new CustomEvent('--get-token-finish', {});
                    document.dispatchEvent(tokenGetEvent);
                });
            }).catch((error) => {
                if (error instanceof Error) {
                    validationResult.add('token', error.message);
                    this.setState({ errors: errors });
                }
                throw error;
            });
            return;
        }
        if (this.state.onlyUnivapayMerchant) {
            checkoutUnivapayToken(this.state.onlyUnivapayMerchant)
                .then((transactionToken) => {
                this.setState({
                    card: { ...transactionToken }
                }, () => {
                    this.submit();
                    // コンポーネント間のイベントバインド
                    const tokenGetEvent = new CustomEvent('--get-token-finish', {});
                    document.dispatchEvent(tokenGetEvent);
                });
            }).catch((error) => {
                window.alert('入力内容に誤りがあります。ご確認ください。');
                const invalidateEvent = new CustomEvent('--get-token-invalidate', {});
                document.dispatchEvent(invalidateEvent);
                throw error;
            });
            return;
        }
        const errors = CardBrand.validate(this.state.card);
        this.setState({ errors: errors });
        if (errors.hasErrors() === false) {
            // トークン取得
            const cardBrandType = CardBrand.detectCardBrand(this.state.card.cardno);
            Tokens.getStoreType(this.props.storeId, cardBrandType).then(response => {
                const { storeId, storeType, storeIdentifier, storeSecrets } = response.data;
                document.addEventListener('--get-token', e => {
                    const evt = e;
                    const tokens = evt.detail.tokens;
                    const card = this.state.card;
                    card.tokens = tokens;
                    card.cardBrandType = cardBrandType;
                    // トークンを取得できた場合は詰める
                    this.setState({
                        card: card
                    });
                    // 次の画面へ遷移
                    this.submit();
                    // コンポーネント間のイベントバインド
                    const tokenGetEvent = new CustomEvent('--get-token-finish', {});
                    document.dispatchEvent(tokenGetEvent);
                }, { once: true });
                Tokens.getToken(this.state.card, storeType, storeId, storeIdentifier, storeSecrets).catch(e => {
                    // トークン取得に失敗した場合
                    const error = e;
                    errors.add('token', error.message);
                    this.setState({ errors: errors });
                    throw e;
                });
            }).catch(e => {
                // 有効なカードブランドが見つからない場合
                errors.add('token', 'お取り扱いできないカードブランドです。アイコンに表示されているブランドのみご利用可能です。');
                this.setState({ errors: errors });
                throw e;
            });
        }
        else {
            const invalidateEvent = new CustomEvent('--get-token-invalidate', {});
            document.dispatchEvent(invalidateEvent);
        }
    }
    hasError(field) {
        return this.state.errors.hasError(field);
    }
    messages(field) {
        return this.state.errors.getMessage(field).map(m => (_jsx("p", Object.assign({ class: "help is-danger" }, { children: m }), void 0)));
    }
    getPaymentFormObject() {
        let formParams = null;
        if (this.state.card.payType === "INPUT") {
            // カード入力で必要なパラメータを設定
            const { cardBrandType, tokens, payType, cardno, paymentMethod, payTimes } = this.state.card;
            formParams = {
                cardBrand: cardBrandType,
                cardInputType: payType,
                cardTokens: tokens,
                cardNo: `************${cardno?.substr(cardno.length - 4)}`,
                paymentMethod: paymentMethod,
                paytime: payTimes
            };
        }
        else {
            const { id, cardBrandType, cardSequence, maskedCardNo, memberCode, token } = this.state.userCard;
            const { payType, paymentMethod, payTimes } = this.state.card;
            formParams = {
                cardBrand: cardBrandType,
                cardInputType: payType,
                cardTokens: [memberCode, token ?? ''],
                cardNo: maskedCardNo,
                paymentMethod: paymentMethod,
                paytime: payTimes,
                cardId: id,
                cardSequence: cardSequence
            };
        }
        return formParams;
    }
    /**
     * コンポーネント間のイベントフック(これを使って決済APIらへんを呼ぶ)
     */
    submitHook() {
        if (this.state.card.payType === "INPUT") {
            this.getToken();
        }
        else {
            //
            // 登録済みカードの場合は何もしない
            const tokenGetEvent = new CustomEvent('--get-token-finish', {});
            document.dispatchEvent(tokenGetEvent);
        }
    }
}
window.addEventListener('load', () => {
    const mountTo = document.querySelector('#PaymentMethodComponent');
    if (mountTo) {
        const storeId = Number(mountTo.getAttribute('data-store-id'));
        const storeType = mountTo.getAttribute('data-store-type') ?? '';
        const cartType = mountTo.getAttribute('data-cart-type') ?? 'CART';
        render(_jsx(PaymentMethodComponent, { storeId: storeId, storeType: storeType, cartType: cartType }, void 0), mountTo);
    }
});
